import Cookies from 'js-cookie'

const TokenKey = 'ed_user_permission_token'
const INVITE_CODE = 'invite_code'
const cartNum = 'user_cart_num'
const loginStatus = 'user_login_status'
const AccountName = 'user_account_name'
const VisitPageId = 'check_visit_home_page_ip'
const ACCOUNT_NO = 'user_account_no'
const SHOW_HOME_COMMUNITY_DIALOG = 'show_home_dialog_dialog'


export function getToken() {
    return Cookies.get(TokenKey)
}
export function setToken(token) {
    return Cookies.set(TokenKey, token, { expires: 30 })
}

export function getCartNum() {
    return Cookies.get(cartNum)
}
export function setCartNum(num) {
    return Cookies.set(cartNum, num, { expires: 30 })
}

export function getLoginStatus() {
    return Cookies.get(loginStatus)
}
export function setLoginStatus(status) {
    return Cookies.set(loginStatus, status, { expires: 30 })
}

export function getAccountName() {
    return Cookies.get(AccountName)
}
export function setAccountName(name) {
    return Cookies.set(AccountName, name, { expires: 30 })
}

export function getAccountNo() {
    return Cookies.get(ACCOUNT_NO)
}
export function setAccountNo(account_no) {
    return Cookies.set(ACCOUNT_NO, account_no, { expires: 30 })
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

export function getInvite() {
    let i = Cookies.get(INVITE_CODE);
    return i ? i : '';
}

export function setInvite(code) {
    return Cookies.set(INVITE_CODE, code, { expires: 7 })
}

export function removeInvite() {
    return Cookies.remove(INVITE_CODE)
}

export function getVisitPageId() {
    return Cookies.get(VisitPageId)
}
export function setVisitPageId(id) {
    return Cookies.set(VisitPageId, id, { expires: 30 })
}
export function setHomeCommunity() {
    return Cookies.set(SHOW_HOME_COMMUNITY_DIALOG, 1, { expires: 2 })
}
export function getHomeCommunity() {
    return Cookies.get(SHOW_HOME_COMMUNITY_DIALOG)
}

export function removeAllCookie() {
    Cookies.remove(TokenKey)
    Cookies.remove(cartNum)
    Cookies.remove(loginStatus)
    Cookies.remove(AccountName)
    Cookies.remove(VisitPageId)


    return true
}
